module.exports = __webpack_public_path__ + "img/yellow-bottle.75a44755.png";